import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isValid } from "services/api";
import { getAuth } from "services/auth";

import { Routes as PublicRoutes, Routes } from "ui/modules/public/navigation";
import { AuthWrapperProps, AuthWrapperCmp } from "./types";

/**
 * Component that checks if user is logged in and renders loader while it does that
 * LOGGED IN -> forwards him to the url he wanted to visit or to Home '/'
 * NOT LOGGED IN -> transfers him to login with query parameter forwardUrl of URL he wanted to visit
 */
export const AuthWrapper: AuthWrapperCmp = (props: AuthWrapperProps) => {
  const { 
    children,
  } = props;
  const [userValidated, setUserValidated] = React.useState(false);
  const auth = useSelector(getAuth);
  const { pathname, search } = useLocation();
  const navigate = useNavigate();


  const isLoginRoute =
    pathname === PublicRoutes.LoginPage ||
    pathname === PublicRoutes.ForgotPasswordPage ||
    pathname === PublicRoutes.RegistrationPage;

    React.useEffect(() => {
      const updateUserValidation = async () => {
        if (isValid(auth)) {
          // if user wanted to go to login redirect him to home or forward url if there is some
          if (pathname.indexOf(PublicRoutes.LoginPage) === 0) {
            const url = pathname + search;
            const forwardUrl = url.split('forwardUrl=').slice(1).join('');
            const forwardUrlResolved = forwardUrl || Routes.HomePage;
            navigate(forwardUrlResolved);
          }
        } else if (
          !isLoginRoute &&
          pathname.indexOf(PublicRoutes.LoginPage) === -1
        ) {
          // if user didn't want to go to login redirect him there and put current
          // pathname as forward Url
          navigate(PublicRoutes.LoginPage, { replace: true })
          // replace({
          //   pathname: PublicRoutes.LoginPage,
          //   search: calculateForwardUrl(pathname, search),
          // });
  
          // Show error if error happend when force log out
          // if (auth._status.errorMessage) {
          //   showNotification(auth._status.errorMessage, { variant: 'error' });
          // }
  
        }
        setUserValidated(true);
      };
  
      updateUserValidation();
    }, [pathname, search, auth, isLoginRoute]);

  // React.useEffect(() => {
  //   const updateUserValidation = async () => {
  //     // if user wanted to go to login redirect him to home or forward url if there is some
  //     if (pathname.indexOf(PublicRoutes.LoginPage) === 0) {
  //       const url = pathname + search;
  //       const forwardUrl = url.split("forwardUrl=").slice(1).join("");
  //       const forwardUrlResolved = forwardUrl || Routes.HomePage;
  //       navigate(forwardUrlResolved);
  //     } else if (
  //       !isLoginRoute &&
  //       pathname.indexOf(PublicRoutes.LoginPage) === -1
  //     ) {
  //       navigate(PublicRoutes.LoginPage);
  //     }
  //     setUserValidated(true);
  //   };

  //   updateUserValidation();
  // }, [pathname, search, isLoginRoute]);

  return children;
};

export default AuthWrapper;
